import { createReducer } from 'redux-act';
import * as actions from '#app/actions/payment';

interface PaymentState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: PaymentState = {
  modalVisible: false,
  form: {},
};

const setPaymentModalVisible = (state: PaymentState, bool: boolean): PaymentState => ({
  ...state,
  modalVisible: bool,
});

const setPaymentForm = (state: PaymentState, form: Record<string, unknown>): PaymentState => ({
  ...state,
  form: form,
});

export default createReducer<PaymentState>(
  {
    [actions.setPaymentModalVisible as any]: setPaymentModalVisible,
    [actions.setPaymentForm as any]: setPaymentForm,
  },
  initialState
);
